const B_1 = [
    {
        title: '添加成交公告',
        path: '/bidding/projectflow/dingbiao/frame-agreement/deal-notice/list'
    }
]
export default{
    path:"deal-notice",
    component:() => import(/*webpackChunkName: 'bidding-projectflow-dingbiao-frame-agreement-deal-notice'*/ '@layout/empty'),
    children:[
        {
            path:"list",
            component:() => import('@views/bidding/views/project-flow/ding/frame-agreement/deal-notice/list'),
            meta: {
                title: '成交公告列表',
                bread: B_1
            },
        },
        {
            path:"form",
            component:() => import('@views/bidding/views/project-flow/ding/frame-agreement/deal-notice/form'),
            meta: {
                title: '添加/修改成交公告',
                bread: B_1
            },
        },
        {
            path:"detail",
            component:() => import('@views/bidding/views/project-flow/ding/frame-agreement/deal-notice/detail'),
            meta: {
                title: '查看成交公告',
                bread: B_1
            },
        },
    ]
}